__turbopack_context__.v({
  "titleLink": "ArticleItemTitleLink-module-scss-module__m1zjaa__titleLink",
});
